/**
 * Weeztix OAuth API Type Definitions
 */

/**
 * Possible status values for the health check
 */
export type WeeztixStatusType = 'healthy' | 'warning' | 'error'

/**
 * Response structure when authenticated and healthy
 */
export interface WeeztixHealthyResponse {
  status: 'healthy' | 'warning'
  authenticated: true
  accessTokenExpiresIn: string
  refreshTokenExpiresIn: string
  warning?: string
}

/**
 * Response structure when not authenticated or tokens expired
 */
export interface WeeztixErrorResponse {
  status: 'error'
  authenticated: false
  message: string
}

/**
 * Union type for all possible health check responses
 */
export type WeeztixHealthResponse =
  | WeeztixHealthyResponse
  | WeeztixErrorResponse

/**
 * Response structure for OAuth callback
 */
export interface WeeztixCallbackResponse {
  success: boolean
  message: string
}

/**
 * Internal component state for managing health data
 */
export interface WeeztixHealthState {
  status: WeeztixStatusType
  authenticated: boolean
  accessTokenExpiresIn?: string
  refreshTokenExpiresIn?: string
  message?: string
  warning?: string
}

/**
 * Type guard to check if response is authenticated
 */
export function isAuthenticated(
  response: WeeztixHealthResponse
): response is WeeztixHealthyResponse {
  return response.authenticated === true
}

/**
 * Type guard to check if response is an error
 */
export function isError(
  response: WeeztixHealthResponse
): response is WeeztixErrorResponse {
  return response.authenticated === false
}
